export const RETAILER_SELECTION_OPTIONS_KEY = "retailer_selection_options";
export const BOTTOM_NAV_RETAILER_SELECTION_KEY = "bottom_nav_selected_retailer";
export const ALL_RETAILERS_VALUE = "allRetailers";

// Old page-level filter cookies. No longer written; still wiped on logout / workspace switch.
export const LEGACY_PAGE_LEVEL_RETAILER_SELECTION_KEYS = [
  "overview_dashboard_selected_retailer",
  "generalKPI_dashboard_selected_retailer",
  "heatmap_dashboard_selected_retailer",
  "optimization_dashboard_selected_retailer",
  "profitability_dashboard_selected_retailer",
  "instoreDuration_dashboard_selected_retailer",
  "trolleyUsage_dashboard_selected_retailer",
];

export const RETAILER_SELECTION_COOKIE_KEYS = [
  RETAILER_SELECTION_OPTIONS_KEY,
  BOTTOM_NAV_RETAILER_SELECTION_KEY,
  ...LEGACY_PAGE_LEVEL_RETAILER_SELECTION_KEYS,
];
